import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ProductionService } from '../../prod/production.service';
import { config } from '../../config';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-percent-or-currency-selector',
  templateUrl: './percent-or-currency-selector.component.html',
  styleUrls: ['./percent-or-currency-selector.component.scss']
})
export class PercentOrCurrencySelectorComponent implements OnInit {
  @Input() currency!: string | null
  @Input() dimension$!: BehaviorSubject<OttaDimensions>
  @Input() allowPercent!: boolean
  
  private prodSvc = inject(ProductionService); 
  
  prodDefaults$ = this.prodSvc.prodDefaults$;
  
  constructor() { }

  ngOnInit(): void {
    console.assert(this.currency !== undefined, 'currency must be set for PercentOrCurrencySelectorComponent')
    console.assert(this.dimension$ !== undefined, 'dimension must be set for PercentOrCurrencySelectorComponent')
    console.assert(this.allowPercent !== undefined, 'allowPercent must be set for PercentOrCurrencySelectorComponent')
  }

  toggleDimension(): void {
    if (this.dimension$.value === OttaDimensions.Currency) {
      this.dimension$.next(OttaDimensions.Percent)
    } else {
      this.dimension$.next(OttaDimensions.Currency)
    }
  }
}

export enum OttaDimensions {
  Currency = 0,
  Percent = 1,
}
